import React from 'react';
// inicjalizacja i18n (side-effect import)
import './i18n';
import { createRoot } from 'react-dom/client';
// 1. Zmień importy: usuń BrowserRouter, dodaj createBrowserRouter i RouterProvider
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import App from './App';
import { ThemeProvider } from './contexts/ThemeProvider';
import { NotificationProvider } from './contexts/NotificationProvider';
import './index.css';
import './grid.css';
import { initAnalytics, disableAnalytics } from './utils/analytics'

// Initialize analytics if user already gave consent (no force by default)
initAnalytics();

// React to consent changes from other tabs/windows
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'cookie_accepted') {
      if (e.newValue === '1') initAnalytics(true);
      else disableAnalytics();
    }
  });
}
// 2. Utwórz router za pomocą createBrowserRouter
const router = createBrowserRouter(
  [
    {
      // Użyj gwiazdki, aby dopasować wszystkie ścieżki,
      // a komponent <App /> zajmie się resztą routingu wewnątrz siebie.
      path: '*',
      Component: App,
    },
  ],
  {
    // Tutaj dodajesz flagi przyszłości
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  },
);

const root = createRoot(document.getElementById('root'));

// 3. Zastąp <BrowserRouter> komponentem <RouterProvider> w metodzie render
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <NotificationProvider>
        <RouterProvider router={router} future={{ v7_startTransition: true, v7_relativeSplatPath: true }} />
      </NotificationProvider>
    </ThemeProvider>
  </React.StrictMode>,
);